import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

console.log("🚀 Pronuve uygulaması başlatılıyor...");

const root = ReactDOM.createRoot(document.getElementById('root'));
console.log("✅ React DOM root oluşturuldu");

root.render(
    <App />
);
